import { memo } from "react";

import { Typography } from "@components/atoms/typography";

export const TextSeparator = memo(function TextSeparator() {
  return (
    <Typography color={"inherit"} fontSize={"base"} disableSelect>
      {"/\r"}
    </Typography>
  );
});
